import React, { useState, useEffect, useCallback } from "react";
import { Select, message } from "antd";
import { connect } from "dva";
import { LoadStatus, LoadStatusMap } from "@/utils/enum";
import { updateLoadStatus } from "@/services/loads";

const { Option } = Select;

const LoadStatusButton = ({ status, loadId, configPerm, refreshData }) => {
  const [statusValue, setStatusValue] = useState(status);
  const [prevStatusValue, setPrevStatusValue] = useState(status);

  useEffect(() => {
    setStatusValue(status);
    setPrevStatusValue(status);
  }, [status]);

  const updateShipmentStatus = useCallback(
    value => {
      if (value === LoadStatus.Completed) {
        const hide = message.loading("Updating load status...");
        setStatusValue(value);

        const payload = {
          id: loadId,
          status: value,
        };

        updateLoadStatus(payload)
          .then(response => {
            hide();
            if (response?.error) {
              message.warning("Can't update load to selected status");
              setStatusValue(prevStatusValue);
            } else {
              message.success("Load status set to completed!");
              setPrevStatusValue(value);
              typeof refreshData === "function" && refreshData();
            }
          })
          .catch(err => {
            console.log(err);
            message.error("Could not update load status");
            setStatusValue(prevStatusValue);
          });
      }
    },
    [loadId, prevStatusValue],
  );

  if ([LoadStatus.Completed, LoadStatus.Incomplete].includes(statusValue)) {
    <span style={{ fontWeight: 600 }}>{LoadStatusMap[statusValue]}</span>;
  }

  return (
    <>
      {configPerm["CoreService.AdminShipments.UpdateStatus"] ? (
        <Select
          style={{ width: 150 }}
          value={statusValue}
          onChange={updateShipmentStatus}
          onClick={e => e.stopPropagation()}
        >
          <Option value={LoadStatus.Delivered}>
            <span style={{ fontWeight: 600 }}>{LoadStatusMap[LoadStatus.Delivered]}</span>
          </Option>
          <Option value={LoadStatus.Completed}>
            <span style={{ fontWeight: 600 }}>{LoadStatusMap[LoadStatus.Completed]}</span>
          </Option>
        </Select>
      ) : (
        <span>{LoadStatusMap[LoadStatus.Delivered]}</span>
      )}
    </>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(LoadStatusButton);
